exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb_20[data-v-78383a1e] {\n  margin-bottom: 0.104167rem;\n}\n.label[data-v-78383a1e] {\n  margin-bottom: 0.052083rem;\n}\n[data-v-78383a1e] .el-dialog {\n  width: 3.125rem;\n}", ""]);

// exports
